import { PublicUserDocument } from 'models/user';

export default function SellerProfileInfo({
  user,
  sellerLocation,
}: {
  user: PublicUserDocument;
  sellerLocation?: string;
}) {
  return (
    <div className="mt-8 flex grow flex-col gap-[2.4rem] px-12 pt-5 text-[1.5rem]">
      <h3 className="text-[2.5rem] font-semibold text-black sm:text-[1.8rem]">
        About this Seller
      </h3>

      {user.bio ? (
        <p className="text-[2.1rem] font-medium text-brand-dark-gray sm:text-[1.8rem]">
          {user.bio}
        </p>
      ) : (
        <p className="text-[2.1rem] font-medium text-zinc-700 sm:text-[1.8rem]">
          This seller has no bio.
        </p>
      )}
    </div>
  );
}
